import ajaxService from './ajaxService';

export default {
  // 取得專員服務資料
  getAgentService(param) {
    const queryString = new URLSearchParams(param).toString();

    return ajaxService.post(`/mcs/get/api/v1/setting/agentservice?${queryString}`);
  },
};
